import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";

import Cookies from "js-cookie";
import React from "react";
import {useTranslation} from "react-i18next";

import {useNavigate} from "react-router-dom";

import Logo from "../assets/ekassaLogo.png";
import {useAuth} from "../context/AuthContext";

export default function TopBar() {
	let navigate = useNavigate();
	const {t} = useTranslation();
	const [auth, setAuth] = React.useState(false);

	const {user, refresh} = useAuth()

	React.useEffect(() => {
		if (Cookies.get("auth")) {
			setAuth(true);
		} else {
			setAuth(false);
		}
	}, []);

	function setLang() {
		if (Cookies.get("simpalsid.lang")) {
			let currentLang = Cookies.get("simpalsid.lang");

			if (currentLang === "ru") {
				Cookies.set("simpalsid.lang", "ro");
			}
			if (currentLang === "ro") {
				Cookies.set("simpalsid.lang", "ru");
			}
		} else {
			Cookies.set("simpalsid.lang", "ru");
		}
		window.location.reload(false);
	}

	function exitBtn() {
		Cookies.remove("auth");
		Cookies.remove("simpalsid.lang");
		refresh()
		// navigate("/app/login");
	}

	return (
		<Box sx={{flexGrow: 1, position: "absolute", width: "100%"}}>
			<AppBar sx={{backgroundColor: "#313238", height: "76px"}}>
				<Toolbar>
					<IconButton
						size="large"
						edge="start"
						color="inherit"
						aria-label="menu"
						sx={{
							mr: 2,
							marginRight: "30px",
							height: "76px",
							width: "162px",
							alignItems: "center",
							justifyContent: "center",
							objectFit: 'contain',
						}}
					>
						<img
							src={Logo}
							style={{maxHeight: "36px", top: "50%", width: '100%'}}
							alt="logo"
							onClick={() => {
								navigate("/");
							}}
						/>
					</IconButton>
					<Typography
						variant="h6"
						component="div"
						sx={{flexGrow: 1}}
					></Typography>

					<Button
						variant="outlined"
						sx={{
							color: "#1976d2",
							borderColor: "#1976d2",
							marginRight: 1,
							display: auth ? "block" : "none",
						}}
						onClick={exitBtn}
					>
						<b>{t("exit")}</b>
					</Button>

					<Button
						variant="outlined"
						sx={{color: "#1976d2", borderColor: "#1976d2"}}
						onClick={setLang}
					>
						<b>{Cookies.get("simpalsid.lang") || "RU"}</b>
					</Button>
				</Toolbar>
			</AppBar>
		</Box>
	);
}
